import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class ClusterCombo extends Component {
    constructor() {
        super()
        this.state = {
            clusterComboList: {},
            selectedCity:{}
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getClusterComboList(this.props.city_id,this.props.cluster_id)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }


    getClusterComboList = (city_id,cluster_id) => {
        apiService.getClusterComboDetailList(city_id,cluster_id)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        clusterComboList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.clusterComboList).map((value,index) => {
                return {
                    label : this.state.clusterComboList[value],
                    value : value
                }            
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div style={{alignItems: 'left'}}>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Cluster"
                options={list}
                onChange={(e) => { (e) ? this.props.clusterChange(e) : this.props.clusterChange([])}}
                />
            </div>
        )
    }
}
export default ClusterCombo


// WEBPACK FOOTER //
// ./src/common/DropDowns/ClusterCombo.js